import { render, staticRenderFns } from "./statusChild.vue?vue&type=template&id=16d6b382&scoped=true"
import script from "./statusChild.vue?vue&type=script&lang=js"
export * from "./statusChild.vue?vue&type=script&lang=js"
import style0 from "./statusChild.vue?vue&type=style&index=0&id=16d6b382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d6b382",
  null
  
)

export default component.exports